import { render, staticRenderFns } from "./FeaturedSlides.vue?vue&type=template&id=28077e10&scoped=true"
import script from "./FeaturedSlides.vue?vue&type=script&lang=js"
export * from "./FeaturedSlides.vue?vue&type=script&lang=js"
import style0 from "./FeaturedSlides.vue?vue&type=style&index=0&id=28077e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28077e10",
  null
  
)

export default component.exports